// i18n area 'tasks' — locale ro-RO (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.ro-RO.meta.json.
import type { enUS } from './tasks'

export const roRO: typeof enUS = {
  macrotasks: {
    title: 'Macrotaskuri',
    subtitle: 'Operații compuse — se pot relua de la pasul eșuat sau se pot întrerupe',
    colType: 'Tip',
    colTarget: 'Obiect',
    colPhase: 'Fază',
    colSteps: 'Pași',
    empty: 'Niciun macrotask',
    detail: 'Detalii',
    failedAt: 'eșuat la',
    resume: 'Reîncearcă de la pasul eșuat',
    abort: 'Întrerupe tot',
    cancel: 'Anulează',
    actionError: 'Acțiunea a fost refuzată'
  },
  tasks: {
    title: 'Taskuri',
    searchPlaceholder: 'Caută după tip sau target',
    type: 'Tip',
    target: 'Target',
    phaseLabel: 'Fază',
    progress: 'Progres',
    started: 'Început',
    finished: 'Terminat',
    node: 'Nod',
    empty: 'Niciun task',
    loadError: 'Nu s-au putut încărca taskurile — este accesibil backend-ul TVirt?',
    limboHint: "Nodul '{node}' este inaccesibil de la {time} — taskul reține write lease-ul pe targetul său până când nodul revine sau este atestat stins",
    nodeAttested: 'Nod atestat stins',
    phase: {
      queued: 'În coadă',
      running: 'În execuție',
      succeeded: 'Finalizat',
      failed: 'Eșuat',
      cancelled: 'Anulat',
      'failed-at-step': 'Eșuat la un pas',
      aborted: 'Întrerupt'
    },
    dropdown: {
      tooltip: 'Taskuri în curs',
      title: 'Taskuri în curs',
      empty: 'Niciun task în curs',
      viewAll: 'Vezi toate taskurile'
    },
    detail: {
      open: 'Detalii',
      scope: 'Scope',
      message: 'Mesaj',
      params: 'Parametri',
      result: 'Rezultat',
      errorTitle: 'Eroare',
      steps: 'Pași',
      failedAt: 'eșuat la',
      superseded: 'înlocuit',
      step: 'Pas',
      parent: 'Task părinte',
      failedStep: 'Pas eșuat',
      log: 'Log',
      logEmpty: 'Încă nicio linie de log',
      close: 'Închide'
    },
    actions: {
      cancel: 'Anulează',
      resume: 'Reîncearcă de la pasul eșuat',
      abort: 'Întrerupe tot (undo al pașilor finalizați)',
      refused: 'Acțiunea a fost refuzată'
    }
  },
  events: {
    loadError: 'Jurnalul nu a putut fi încărcat — backendul TVirt este accesibil?',
    title: 'Evenimente',
    subtitle: 'Memoria istorică a clusterului: fapte împlinite, de la cele mai recente',
    filterSeverity: 'Gravitate',
    filterCategory: 'Categorie',
    filterAll: 'Toate',
    searchLabel: 'Caută',
    searchPlaceholder: 'Caută în tot jurnalul',
    subjectFilter: 'Evenimentele {subject} — arată toate',
    colAt: 'Când',
    colSeverity: 'Gravitate',
    colType: 'Tip',
    colSubject: 'Subiect',
    colActor: 'Cine',
    colNode: 'Node',
    colMessage: 'Mesaj',
    empty: 'Niciun eveniment',
    loadMore: 'Încarcă mai multe',
    actorSystem: 'sistem',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID eveniment',
    taskCollectedHint: 'Taskul are o retenție mai scurtă: odată colectat, legătura nu mai răspunde',
    severity: {
      info: 'Informație',
      warning: 'Avertisment',
      error: 'Eroare',
      critical: 'Critic'
    },
    category: {
      lifecycle: 'Ciclu de viață',
      config: 'Configurație',
      availability: 'Disponibilitate',
      security: 'Securitate'
    },
    type: {
      haNetsvcFailedOver: 'Failover al serviciului de rețea',
      haNetsvcNoCandidate: 'Serviciu de rețea fără nod candidat',
      haNetsvcReaped: 'Instanță locală secerată la revenirea nodului',
      netsvcFloatipMoved: 'IP flotant mutat la alt deținător',
      netsvcFloatipNoHolder: 'IP flotant fără țintă sănătoasă',
      haAppFailedOver: 'Failover al instanței App',
      haAppNoCandidate: 'Instanță App fără nod candidat',
      haAppStorageLocalSkip: 'Instanță App nemutată: date persistente locale pe nodul mort',
      haAppReaped: 'Podul local al instanței App secerat la revenire'
    }
  },
  audit: {
    loadError: 'Registrul de audit nu a putut fi încărcat — backendul TVirt este accesibil?',
    title: 'Audit',
    subtitle: 'Cine ce a făcut, când și asupra cărui obiect — acte încercate, refuzurile incluse',
    filterOutcome: 'Rezultat',
    filterAll: 'Toate',
    filterSudo: 'Doar acte elevate',
    colAt: 'Când',
    colActor: 'Cine',
    colAction: 'Acțiune',
    colTarget: 'Obiect',
    colOutcome: 'Rezultat',
    colNode: 'Node',
    empty: 'Niciun act înregistrat',
    loadMore: 'Încarcă mai multe',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Rută',
    detailProblem: 'Motiv',
    detailTask: 'Task',
    detailClientIp: 'De la',
    detailId: 'ID înregistrare',
    detailSession: 'Sesiune',
    taskHint: 'Rezultatul unui act acceptat trăiește în jurnalul de evenimente, sub același id de task',
    outcome: {
      succeeded: 'Reușit',
      accepted: 'Acceptat',
      denied: 'Refuzat',
      rejected: 'Respins',
      failed: 'Eșuat'
    }
  },
  notifications: {
    loadError: 'Notificările nu au putut fi încărcate — backendul TVirt este accesibil?',
    actionError: 'Acțiunea a fost refuzată',
    title: 'Notificări',
    subtitle: 'Destinațiile către care faptele jurnalului părăsesc clusterul',
    rulesTitle: 'Reguli',
    rulesSubtitle: 'Ce fapte ies și către unde',
    deliveriesTitle: 'Livrări',
    deliveriesSubtitle: 'Rezultatul fiecărei notificări, cu motivul atunci când eșuează',
    colName: 'Nume',
    colKind: 'Tip',
    colWhere: 'Unde',
    colScope: 'Scope',
    colSeverity: 'Gravitate',
    colMatch: 'Filtru',
    colTargets: 'Destinație',
    colAt: 'Când',
    colState: 'Stare',
    colEvent: 'Eveniment',
    colAttempts: 'Încercări',
    colOutcome: 'Rezultat',
    empty: 'Niciun rând',
    matchAll: 'toate faptele',
    test: 'Testează',
    testOk: 'Notificare de test livrată către {target}',
    testFailed: 'Testul către {target} a eșuat: {reason}',
    retry: 'Repune în coadă',
    retried: 'Livrare repusă în coadă',
    grouped: 'și încă {count} repetări',
    state: {
      failed: 'Eșuată',
      pending: 'În coadă',
      sending: 'Se trimite',
      sent: 'Trimisă'
    },
    tabTargets: 'Destinații',
    tabRules: 'Reguli',
    tabDeliveries: 'Livrări',
    targetCreateTitle: 'Destinație nouă',
    ruleCreateTitle: 'Regulă nouă',
    nameHint: 'Litere mici, cifre și cratime; unic pe domeniu',
    kindImmutableHint: 'Imutabil: schimbarea tipului înseamnă crearea unei alte destinații',
    kindSmtp: 'Poștă (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Stare',
    enabledOn: 'Activă',
    enabledOff: 'Suspendată',
    smtpHost: 'Server SMTP',
    smtpPort: 'Port',
    smtpPortHint: 'Obișnuit: 25 fără TLS, 587 cu starttls, 465 cu tls',
    smtpSecurity: 'Securitate',
    smtpFrom: 'Expeditor',
    smtpTo: 'Destinatari',
    smtpToHint: 'Una sau mai multe adrese separate prin virgulă',
    webhookUrl: 'URL',
    payload: 'Conținut',
    payloadHint: 'Cu minimal mesajul și datele evenimentului nu părăsesc clusterul',
    credential: 'Credențial',
    credentialNone: 'Niciunul',
    credentialHintSmtp: 'Contul releului din keystore; niciunul înseamnă SMTP anonim',
    credentialHintWebhook: 'Secretul de semnare din keystore; fără semnătură, oricine știe URL-ul se poate da drept cluster',
    minSeverityHint: 'Un prag, nu o mulțime: de la această gravitate în sus',
    categories: 'Categorii',
    categoriesHint: 'Gol = toate',
    types: 'Tipuri de eveniment',
    typesHint: 'Separate prin virgulă; gol = toate. Un tip necunoscut este refuzat',
    targetsHint: 'Cel puțin una; trebuie să fie în domeniul regulii sau într-un strămoș al lui',
    recursiveOn: 'Și domeniile copil',
    recursiveOff: 'Doar acest domeniu',
    recursiveHint: 'Resursele trăiesc în frunze: fără copii, o regulă pe rădăcină notifică aproape nimic',
    repeatWindow: 'Fereastră de grupare (s)',
    repeatWindowHint: 'În fereastră repetările nu trimit poștă: sunt numărate la prima. 0 dezactivează',
    targetInUseError: 'Destinația {name} este încă folosită de o regulă'
  }
}
